import { render, staticRenderFns } from "./cdxAndPbx.vue?vue&type=template&id=25f1fdea&scoped=true"
import script from "./cdxAndPbx.vue?vue&type=script&lang=js"
export * from "./cdxAndPbx.vue?vue&type=script&lang=js"
import style0 from "./cdxAndPbx.vue?vue&type=style&index=0&id=25f1fdea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f1fdea",
  null
  
)

export default component.exports